export default "__VITE_PUBLIC_ASSET__32f1ef89__"